// import axios from 'axios';
// import { request } from './axiosFun';
// export const deviceList = (params) => { return request("post", "/est/api/pcController/getDeviceByUser", params) };
// export cons
import request  from './axiosFun';
// 人员列表
 var url = ''
   if (process.env.NODE_ENV === "development") {
     url = '/est'
   }else {
     url = ''
   }
   export function deviceList(data) {
      return request({
        url: url +'/pasture/cameraDevice/getDsList',
       method: 'post',
       data,
     })
   }



// WEBPACK FOOTER //
// ./src/api/device.js